import { Swiper } from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
import { FadeEffectEvents } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/effect-fade';

const Home = {
  init() {
    if (document.querySelector('.home-hero')) {
      const swiperEl = document.querySelector('.home-hero .swiper') as HTMLElement;
      new Swiper(swiperEl, {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 5000,
        autoplay: {
          delay: 3000,
        },
      });
    }
  },
};
export { Home };
